import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  private etstep1Url = environment.apiBaseUrl + environment.etAddAccount;
  private etstep2Url = environment.apiBaseUrl + environment.etUpdateAccount;
  // private step1Url = environment.baseUrl + environment.SignupStep1;
  // private step2Url = environment.baseUrl + environment.UpdateSignupStep2;
  private getCountryUrl = environment.apiBaseUrl + environment.getCountry;
  private getStateUrl = environment.apiBaseUrl + environment.getState;

  constructor(private http: HttpClient) {}

  signupStep1(data: any): Observable<any> {
    return this.http.post(this.etstep1Url, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }

  signupStep2(data: any): Observable<any> {
    return this.http.post(this.etstep2Url, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(catchError(this.handleError));
  }
getCountries(): Observable<any> {
  return this.http.get(this.getCountryUrl).pipe(catchError(this.handleError));
}

getStates(): Observable<any> {
  return this.http.get(this.getStateUrl).pipe(catchError(this.handleError));
}

  private handleError(error: any) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client Error: ${error.error.message}`;
    } else {
      errorMessage = `Server Error Code: ${error.status}\nMessage: ${error.message || error.error}`;
    }

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
